import { Pipe, PipeTransform } from '@angular/core';

import { AccountGroupMembership } from '@libs/src/models/account.model';

import { filterVisibleGroups } from '../user/user.helpers';

@Pipe({
  name: 'appVisibleGroups',
})
export class VisibleGroupsPipe implements PipeTransform {
  transform(value: AccountGroupMembership[] = []): any {
    return filterVisibleGroups(value);
  }
}
